module.exports = __webpack_public_path__ + "static/media/1012640.ab87f6e1.jpg";